module.exports = __webpack_public_path__ + "img/19_97.09339882.png";